<template>
  <div class="content">
    <LinkPath current-path="consulta griaule"/>
    <section>
      <div class="row">
        <div class="col-md-12">
          <div class="box box-info">
            <div class="form-group">
              <form id="formBio" style="padding: 10px !important;">

                <div id="divAlert" class="alert alert-success" role="alert" style="margin: 16px; display:none;"></div>

                <div class="agent-input-group">
                  <div class="form-row">
                    <div class="col-md-4 mb-3">
                      <label for="cpf">CPF</label>
                      <input type="text" class="form-control cpf" id="cpf" v-model="cpf">
                    </div>
                  </div>
                  <div class="form-group  pesquisa-box">
                    <div class="col-md-1 mb-3">
                      <button id="btnPesq" type="button"
                              v-on:click="searchBiometric()"
                              class="btn btn-primary search-button">
                        Pesquisar
                      </button>
                    </div>
                  </div>
                </div>

                <div style="clear:both;"></div>

              </form>

              <div class="row center-block">
                <div class="col-md-12">
                  <div class="box">
                    <div class="box-body">
                      <div id="divPrint">
                        <div id="titulo" style="display:none;">
                          <h2>Biometrias Cadastradas</h2>
                          <div id="buttons" style="float: right; margin-top: -40px;">

                            <input v-on:click="print()" class="print btn btn-primary" type="button" id="btPrint"
                                   value="Imprimir Laudo Biométrico"/>

                          </div>
                        </div>
                        <br/>
                        <div id="userBio" class="divBlank">
                          <ImageFrame id="face" v-if="imageBase64" :url="imageBase64"/>

                          <div id="hand">
                            <HandFrame
                                v-if="left"
                                :is-left="true"
                                :left-thumb="LeftThumb"
                                :left-index-finger="LeftIndexFinger"
                                :left-middle-finger="LeftMiddleFinger"
                                :left-ring-finger="LeftRingFinger"
                                :left-little-finger="LeftLittleFinger"
                            />

                            <HandFrame
                                v-if="right"
                                :is-right="true"
                                :right-thumb="RightThumb"
                                :right-index-finger="RightIndexFinger"
                                :right-middle-finger="RightMiddleFinger"
                                :right-ring-finger="RightRingFinger"
                                :right-little-finger="RightLittleFinger"
                            />
                          </div>

                          <BioInfo id="bioInfo" :bio-info-list="bioInfoList"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

    </section>
  </div>
</template>

<script>
import $ from 'jquery'
import interceptor from '../../interceptor'
import roles from '../../roles'
import LinkPath from '../components/LinkPath'
import ImageFrame from '../components/ImageFrame'
import HandFrame from '../components/HandFrame'
import DeleteModal from '../components/DeleteModal'
import FraudModal from '../components/FraudModal'
import BioInfo from '../components/BioInfo'

export default {
  name: 'managePsbio',
  components: {BioInfo, FraudModal, DeleteModal, HandFrame, ImageFrame, LinkPath},
  data: function () {
    return {
      audits: [],
      listaBiometrics: [],
      bioInfoList: [],
      cpf: '',
      idn: '',
      description: '',
      safCode: '',
      key: 'MANAGE',
      obs: '',
      motivo: '',
      left: false,
      right: false,
      imageBase64: '',
      RightThumb: false,
      RightIndexFinger: false,
      RightMiddleFinger: false,
      RightRingFinger: false,
      RightLittleFinger: false,
      LeftThumb: false,
      LeftIndexFinger: false,
      LeftMiddleFinger: false,
      LeftRingFinger: false,
      LeftLittleFinger: false
    }
  },
  methods: {
    toggleClassByName(className, id) {
      $(id).toggle(className)
    },
    fillBiometrics(biometrics) {
      biometrics.map((bio) => {
        if (bio.index === 11) {
          this.imageBase64 = `data:image/jpeg;base64,${bio.content}`
        }
        if (bio.index === 6) {
          this.RightThumb = true
        }
        if (bio.index === 7) {
          this.RightIndexFinger = true
        }
        if (bio.index === 8) {
          this.RightMiddleFinger = true
        }
        if (bio.index === 9) {
          this.RightRingFinger = true
        }
        if (bio.index === 10) {
          this.RightLittleFinger = true
        }
        if (bio.index === 1) {
          this.LeftThumb = true
        }
        if (bio.index === 2) {
          this.LeftIndexFinger = true
        }
        if (bio.index === 3) {
          this.LeftMiddleFinger = true
        }
        if (bio.index === 4) {
          this.LeftRingFinger = true
        }
        if (bio.index === 5) {
          this.LeftLittleFinger = true
        }
      })
    },
    checkLeftHand() {
      const leftHand = [this.LeftThumb, this.LeftIndexFinger, this.LeftMiddleFinger, this.LeftRingFinger, this.LeftLittleFinger]
      leftHand.forEach((finger) => {
        if (finger) this.left = true
      })
    },
    checkRightHand() {
      const rightHand = [this.RightThumb, this.RightIndexFinger, this.RightMiddleFinger, this.RightRingFinger, this.RightLittleFinger]
      rightHand.forEach((finger) => {
        if (finger) this.right = true
      })
    },
    check: function (action) {
      return roles.checkrole(window.localStorage.getItem('role'), this.key, action)
    },
    searchBiometric: function () {
      this.clear()
      $('#btnPesq').attr('disabled', true)
      if (this.cpf !== undefined && this.cpf !== '') {
        interceptor.request('get', 'api/v1/psbio/getBiometrics?cpfIdn=' + this.cpf, {})
            .then(response => {
              if (response.data) {
                $('#userBio').attr('class', 'divUserBio')
                this.idn = response.data.idn
                this.listaBiometrics = response.data.biometrics
                $('#titulo').show()
                this.bioInfoList.push([])
                this.bioInfoList.push([])
                this.bioInfoList.push([])
                this.bioInfoList[0].title = 'Informações do cadastro'
                this.bioInfoList[0].infoList = [
                  {property: 'IDN', value: this.idn},
                  {property: 'CPF', value: this.cpf},
                  {property: 'Base', value: 'Griaule'}
                ]

                if (this.listaBiometrics.length > 0) {
                  this.fillBiometrics(this.listaBiometrics)
                  this.checkLeftHand()
                  this.checkRightHand()
                }
              }
            })
            .catch(function (error) {
              let msg = error.response.status
              if (msg === 404) {
                $('#divAlert').attr('class', 'alert alert-danger')
                    .append('<p style="font-weight: bold;">Não foram encontradas Biometrias para o CPF informado.</p>')
                    .show()
              } else {
                $('#divAlert').attr('class', 'alert alert-danger')
                    .append('<p style="font-weight: bold;">Erro ao tentar pesquisar as biometrias. Serviço indisponível.</p>')
                    .show()
              }
            })
      } else {
        $('#divAlert').attr('class', 'alert alert-warning')
            .append('<p style="font-weight: bold;">Por favor insira o CPF que deseja pesquisar.</p>')
            .show()
      }
      setTimeout(() => $('#btnPesq').attr('disabled', false), 2000)
    },
    clear: function () {
      $('#divAlert').empty().hide()
      $('#titulo').hide()
      $('#userBio').attr('class', 'divBlank')
      $('#userBioInfo').attr('class', '')
      $('#userBioInfo').empty()
      $('#userBioException').empty()
      this.bioInfoList = []
      this.left = false
      this.right = false
      this.imageBase64 = ''
      const leftHand = [this.LeftThumb, this.LeftIndexFinger, this.LeftMiddleFinger, this.LeftRingFinger, this.LeftLittleFinger]
      const rightHand = [this.RightThumb, this.RightIndexFinger, this.RightMiddleFinger, this.RightRingFinger, this.RightLittleFinger]
      leftHand.forEach((f) => {
        f = false
      })
      rightHand.forEach((f) => {
        f = false
      })
    },
    print: function () {
      let fingers = ''
      this.listaBiometrics.forEach(b => {
        if (b.translateFinger) {
          fingers = fingers.concat(b.translateFinger, '<br/>')
        }
      })

      const evidenciaHTML = $('#bioInfo').html()
      const faceHTML = `<div><img height="300px" width="auto" src='${this.imageBase64}'/></div>`
      const fingerHTML = `<div style="font-size: 1.5rem;">${fingers}</div>`
      const css = 'font-family: sans-serif; display: flex; flex-direction: column; align-items: center; justify-content: space-around; gap: 1rem;'
      const evidenciaCSS = 'display: flex; align-items: flex-start; justify-content: center; font-size: 14px; gap: 2rem;'
      const content = `<div style="${css}">${faceHTML} ${fingerHTML}<div style="${evidenciaCSS}">${evidenciaHTML}</div></div>`
      // var conteudo = $('#userBio').html()
      const telaImpressao = window.open('about:blank')
      telaImpressao.document.write('<style>@page {size:portrait;}</style>')
      telaImpressao.document.write(content)
      telaImpressao.document.close()
      telaImpressao.window.print()
    }
  },
  mounted() {
  }
}
</script>

<style>
#userBio {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 200px);
  gap: 1rem;
  align-items: start;
  justify-content: center;
  justify-items: start;
}

#userBioInfo {
  grid-column-start: 2;
  grid-row-start: 1;
  grid-row-end: 3;
  overflow-y: scroll;
  border-left: 2px solid #7030C5;
}

@page {
  size: landscape;
}

#userBio {
  display: grid;
  grid-template-rows: repeat(2, 1fr);
  grid-template-columns: repeat(4, 1fr);
}

#face {
  grid-column: 1 / span 2;
  grid-row: 1;
  display: flex;
  justify-self: center;
}

#hand {
  grid-column: 1 / span 2;
  grid-row: 2;
  display: flex;
  justify-self: center;
  gap: 14rem;
}

#userBioInfo {
  grid-column: 3 / span 2;
  grid-row: 1 / span 2;
}

.divUserBioInfoNotFace {
  border-left: 2px solid #7030C5;
  height: 95%;
  width: 100%;
}

.divBlank {
  background-color: white;
  height: 500px;
}

.divUserBio {
  background-color: transparent;
  height: 600px;
  border: 2px solid #7030C5;
  padding: 10px;
  border-radius: 3px;
}

.divUserBioInfo h4 {
  margin-left: 10px;
}

.divUserBioInfo p {
  margin-left: 10px;
}

.divUserBioInfoNotFace h4 {
  margin-left: 10px;
}

.divUserBioInfoNotFace p {
  margin-left: 10px;
}

.imgBio {
  border-radius: 25px;
  width: 30%;
}
</style>



// WEBPACK FOOTER //
// ManagePSBIO.vue?29dc65f3